import http from "helpers/http.js";

// Use the main API URL (same as other services)
const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:44303/';

/**
 * Fetches all enabled games from the API
 * @returns {Promise<Array>} Array of game objects
 */
const getGames = async () => {
    try {
        const response = await http.get(`${API_URL}api/public/games`);
        return response.data;
    } catch (error) {
        console.error('Error fetching games:', error);
        throw error;
    }
};

/**
 * Fetches a single game by its gameId
 * @param {string} gameId - The game identifier (e.g., "catchphrase", "pointless")
 * @returns {Promise<Object>} Game object
 */
const getGameById = async (gameId) => {
    try {
        const response = await http.get(`${API_URL}api/public/games/${encodeURIComponent(gameId)}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching game ${gameId}:`, error);
        throw error;
    }
};

/**
 * Fetches a single game by its store slug
 * @param {string} slug - The store slug (e.g., "catchphrase", "pointless")
 * @returns {Promise<Object>} Game object
 */
const getGameBySlug = async (slug) => {
    try {
        // Remove /shop/ prefix if present
        const cleanSlug = slug.replace(/^\/shop\//, '');
        const response = await http.get(`${API_URL}api/public/games/by-slug/${encodeURIComponent(cleanSlug)}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching game by slug ${slug}:`, error);
        throw error;
    }
};

const gamesService = {
    getGames,
    getGameById,
    getGameBySlug
};

export default gamesService;
